import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a7a4da20&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a7a4da20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a4da20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a4da20')) {
      api.createRecord('a7a4da20', component.options)
    } else {
      api.reload('a7a4da20', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a7a4da20&scoped=true&", function () {
      api.rerender('a7a4da20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Z88rdiB0J6i/JS/comp/PopupBox.vue"
export default component.exports